import React, { useEffect, useState } from 'react'
import { Heading, Page } from '../../components'
import { DropDown } from '../../components/Form/components'
import { metabaseService } from '../../lib'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

export const AnalyticsPage = () => {
  const { developmentId } = useParams();
  const [options, setOptions] = useState([]);
  const [sites, setSites] = useState([]);
  const [dashboardUrl, setDashboardUrl] = useState(null);
  const [selectedDashboard, setSelectedDashboard] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const developments = useSelector((state) => state.developments);
  console.log(developments)
  const getOptions = async() => {
    return await metabaseService.getDashboardsByUsername({userName: JSON.parse(localStorage.getItem('signtouch-user')).username.toLowerCase()});
  }

  const getSites = () => {
    const regions = developments.filter((development) => development.parentId === parseInt(developmentId));
    let sites = [];
    regions.map((region) => {
      sites.push(...developments.filter((development) => development.parentId === region.id));
    });
    return sites.map(({id, name}) => ({
      label: name,
      value: id,
    }));
  }

  const getDashboard = async(dashboardId) => {
    console.log(dashboardId, selectedSite)
    if (!selectedSite) return;
    await metabaseService.getDashboardByDashboardId(dashboardId, selectedSite).then((res) => {
      setDashboardUrl(res.iframeUrl);
      setSelectedDashboard(dashboardId);
    }).catch((e) => {
      console.log(e);
    });
  }

  useEffect(() => {
    getOptions().then((res) => {
      setOptions(()=>
        res.map(({dashboardId, name})=>({
          label: name,
          value: (dashboardId),
        }))
      )
    })
    setSites(getSites());
  }, [])

  useEffect(() => {
    if (selectedDashboard) {
      getDashboard(selectedDashboard);
    }
  }, [selectedSite])
  return (
   <>
    <Page>
      <div className='heading-with-button'>
        <Heading label='Analytics'/>
        <div style={{display: 'flex', gap: '10px'}}>
          <DropDown options={sites} placeholder='Select Site' onChange={(e) => { console.log(e.value); setSelectedSite(parseInt(e.value))}}></DropDown>
          <DropDown options={options} placeholder='Select Dashboard' disabled={!selectedSite} onChange={(e) => getDashboard(parseInt(e.value))}></DropDown>
        </div>
      </div>
      {dashboardUrl && selectedSite ? 
        <iframe
          src={dashboardUrl}
          width={'100%'}
          height={'90%'}
          allowTransparency
          frameBorder={0}
        />
        : <div>
          <p>Select a dashboard from DropDown to view</p>
        </div>
      }
    </Page>
   </>
  )
}
